import { Component, OnInit } from '@angular/core';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { Comando, Recurso, TipoComando } from '../../../../types/smartinteg';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-comando-list',
  templateUrl: './comando-list.component.html',
  styleUrls: ['./comando-list.component.css'],
  providers: [ConfirmationService]
})
export class ComandoListComponent implements OnInit {

  comandos: Comando[] = [];
  recursos: Recurso[] = [];
  loading: boolean = true;

  constructor(
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.carregarComandos();
    this.carregarRecursos();
  }

  carregarComandos(): void {
    this.loading = true;
    this.smartintegService.listarComandos().subscribe({
      next: (data) => {
        this.comandos = data;
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao carregar comandos.');
        this.loading = false;
      }
    });
  }

  carregarRecursos(): void {
    this.smartintegService.listarRecursos().subscribe({
      next: (data) => this.recursos = data
    });
  }

  deletarComando(comando: Comando): void {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja deletar o comando <strong>${comando.nome}</strong>?`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Lógica de deleção
      }
    });
  }

  getTipoComandoIcon(tipo: TipoComando): string {
    return tipo === TipoComando.DATABASE_SQL ? 'pi pi-database' : 'pi pi-globe';
  }
}
